import { Check } from 'react-feather';

interface CheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, onClick }) => {
  return (
    <div
      className="ora-checkbox"
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        if (onClick) {
          onClick(e);
        }
      }}
    >
      <input type="checkbox" checked={checked} onChange={onChange} />
      <div className="ora-checkbox_check">
        <Check />
      </div>
    </div>
  );
};

export default Checkbox;
